
export default {
  name: 'AppDraggableProgressBar',
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isDragging: false,
      dragTime: 0
    };
  },
  computed: {
    progressPercentage() {
      if (!this.max) return 0;

      const time = this.isDragging ? this.dragTime : this.value;
      return (time / this.max) * 100;
    }
  },
  beforeDestroy() {
    this.removeEventListeners();
    document.body.style.userSelect = '';
  },
  methods: {
    onTouchStart(event) {
      if (!this.max || this.isDragging) return;

      const touch = event.touches[0];
      this.isDragging = true;
      document.body.style.userSelect = 'none';
      this.calculateDragTime(touch.clientX);
      this.$emit('drag-start', this.dragTime);
      this.removeEventListeners();
      document.addEventListener('touchmove', this.onTouchMove);
      document.addEventListener('touchend', this.onTouchEnd);
    },
    onTouchMove(event) {
      event.preventDefault();
      const touch = event.touches[0];
      this.calculateDragTime(touch.clientX);
      this.$emit('drag-move', this.dragTime);
    },
    onTouchEnd() {
      this.isDragging = false;
      document.body.style.userSelect = '';
      this.removeEventListeners();
      this.$emit('drag-end', this.dragTime);
    },
    calculateDragTime(clientX) {
      const rect = this.$el.getBoundingClientRect();
      if (!rect.width) return;

      const x = clientX - rect.left;
      const percentage = Math.max(0, Math.min(1, x / rect.width));
      this.dragTime = percentage * this.max;
    },
    onMouseDown(event) {
      if (!this.max || this.isDragging) return;

      this.isDragging = true;
      document.body.style.userSelect = 'none';
      this.calculateDragTime(event.clientX);
      this.$emit('drag-start', this.dragTime);
      this.removeEventListeners();
      document.addEventListener('mousemove', this.onMouseMove);
      document.addEventListener('mouseup', this.onMouseUp);
    },
    onMouseMove(event) {
      event.preventDefault();
      this.calculateDragTime(event.clientX);
      this.$emit('drag-move', this.dragTime);
    },
    onMouseUp() {
      this.isDragging = false;
      document.body.style.userSelect = '';
      this.removeEventListeners();
      this.$emit('drag-end', this.dragTime);
    },
    removeEventListeners() {
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchend', this.onTouchEnd);
      document.removeEventListener('mousemove', this.onMouseMove);
      document.removeEventListener('mouseup', this.onMouseUp);
    }
  }
};
